export default __webpack_public_path__ + "static/media/SEA_8423.e406fa37.jpg";